import { Text } from '#app/components/Primitives/Text.js';
import recommendationPreview from './recommendation-preview.webp';
import recommendationPreviewRetina from './recommendation-preview@2x.webp';
import { css, styled } from 'styled-components';

const Card = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 16px;

    width: 100%;

    padding: 24px 24px 32px;
    margin-left: auto;
    margin-right: auto;

    background-color: ${theme.colorsV2.white};
    border-radius: 20px;
    border: 1px solid ${theme.colorsV2.gray30};

    ${theme.mediaQueries.xl} {
      padding: 32px 32px 48px;
      max-width: 100%;
    }

    > * {
      max-width: 500px;
      text-align: center;
    }
  `}
`;

const Heading = styled(Text)``;
const SubHeading = styled(Text)`
  line-height: 24px;
`;

const RecommendationPreviewImg = styled.img`
  margin-bottom: 24px;
`;

const RecommendationPreviewImage = () => {
  return (
    <RecommendationPreviewImg
      alt="Recommendation Preview"
      height="auto"
      src={recommendationPreview}
      srcSet={`${recommendationPreviewRetina} 2x`}
      width={203}
    />
  );
};

export const IneligibleForRequestRecommendationCard = ({
  subheader = 'Complete your profile to request recommendations from past Clients and Collaborators.',
}: {
  readonly subheader?: string;
}) => {
  return (
    <Card>
      <RecommendationPreviewImage />
      <Heading textStyle="sixthLevelHeadline">
        You haven't received any recommendations yet!
      </Heading>
      <SubHeading>{subheader}</SubHeading>
    </Card>
  );
};
